import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-expand-filter-button',
  templateUrl: './gb-expand-filter-button.component.html',
  styleUrls: ['./gb-expand-filter-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbExpandFilterButtonComponent {}
